import { Capacitor, registerPlugin } from "@capacitor/core";
type NativeSharing = { copyShareLink(options: { text: string }): Promise<{ verified: boolean }>; shareTripLink(options: { text: string; title: string }): Promise<void> };
const NativeFile = registerPlugin<NativeSharing>("TripAiFile");
/** A successful write is insufficient for the automatic-copy claim: read back first. */
export async function copyShareLink(text: string): Promise<boolean> {
  try {
    if (Capacitor.getPlatform() === "android") return (await NativeFile.copyShareLink({ text })).verified === true;
    await navigator.clipboard.writeText(text);
    return await navigator.clipboard.readText() === text;
  } catch { return false; }
}
export async function shareTripLink(text: string, title: string): Promise<void> {
  if (Capacitor.getPlatform() === "android") { await NativeFile.shareTripLink({ text, title }); return; }
  if (!navigator.share) throw new Error("SHARE_UNAVAILABLE");
  await navigator.share({ title, url: text });
}
